import React ,{useEffect,useState, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import {fetchAllWorkInstructions} from '../../../../../util/wi_util'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import exitIcon from "../../../../../assets/Icons/closeImg.png"
import saveIcon from "../../../../../assets/Icons/green-check-mark-verified-circle-16223.png"
import { forEach } from 'lodash';
const filter = createFilterOptions();

export default function EmbeddedWISelect(props) {
    const [showingWIMenu, updateWIMenu] = useState([])
    const [selectedWI,updateSelectedWI] = useState({})
    const [open, setOpen] = useState(false)
    const [inputValue, setInputValue] = useState("")
    const inputRef = useRef(null)
    const containerRef = useRef(null)
    useEffect(() => {
        //alert("made it inside the component")
        fetchAllWorkInstructions().then((data)=>{
            let wiArray = [];
            data.forEach(wi =>{
                wiArray.push({title:wi.title, wip_ID:wi._id })
            })
            updateWIMenu(wiArray)           
            // console.log(wiArray)
            //alert("got it")

        })
    },[])

    // Minimal focus protection similar to Step Editor and PublicationPage
    useEffect(() => {
        // Focus the input when mounted
        try { if (inputRef.current) { inputRef.current.focus(); setOpen(true) } } catch(e) {}

        // Disable tab headers from stealing focus while this selector is open
        const tabHeaders = document.querySelectorAll('.react-tabs__tab')
        tabHeaders.forEach(tab => {
            if (tab.getAttribute('tabindex') !== '-1') {
                tab.setAttribute('data-original-tabindex-wi', tab.getAttribute('tabindex') || '0')
                tab.setAttribute('tabindex', '-1')
            }
        })

        // Trap accidental focus to tab headers back to our input
        const onFocusIn = (e) => {
            const t = e.target
            if (t && t.classList && t.classList.contains('react-tabs__tab')) {
                e.stopPropagation()
                e.preventDefault()
                try { if (inputRef.current && !inputRef.current.disabled) { inputRef.current.focus() } } catch(err) {}
            }
        }
        document.addEventListener('focusin', onFocusIn, true)

        return () => {
            // Restore tab headers' tabindex on unmount
            const tabs = document.querySelectorAll('.react-tabs__tab')
            tabs.forEach(tab => {
                const original = tab.getAttribute('data-original-tabindex-wi')
                if (original !== null) {
                    tab.setAttribute('tabindex', original)
                    tab.removeAttribute('data-original-tabindex-wi')
                }
            })
            document.removeEventListener('focusin', onFocusIn, true)
        }
    }, [])

    // useEffect(() => {
    //   props.attachWIButton(selectedWI)
    // },[selectedWI])



    const saveModal = (e) =>{
        e.preventDefault();
        e.stopPropagation()
        props.attachWIButton(selectedWI)
        props.SetToClose()
    }
    const closeModal = (e) =>{
        e.preventDefault();
        e.stopPropagation()
        props.SetToClose()
    }

    return (
        <div ref={containerRef} style={{ width:"100%" }}>
        <Autocomplete
            open={open}
            onOpen={()=>setOpen(true)}
            onClose={(event, reason)=>{
                // Keep open during typing/focus transitions; close only on escape or selection
                if (reason === 'escape' || reason === 'select-option') { setOpen(false) } else { setOpen(true) }
            }}
            inputValue={inputValue}
        
            onChange={(event, newValue) => {
                console.log(event)
                    // when a previously existing selection is made/cancelled
                    if (newValue && newValue.title && selectedWI.wip_ID != newValue.wip_ID) {
                        updateSelectedWI(newValue)                     
                    }
            }}
            filterOptions={(options) => {
                const q = (inputValue || '').trim().toLowerCase()
                if (!q) return options
                return options.filter(o => (o.title || '').toLowerCase().includes(q))
            }}
            autoSelect
            selectOnFocus
            openOnFocus
            handleHomeEndKeys
            onInputChange={(e, val)=>{ setInputValue(val || ""); setOpen(true) }}
            id="free-solo-with-text-demo"
            options={showingWIMenu}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Regular option
                return option.title;
            }}
            renderOption={(option) => option.title}
            ListboxProps={{ onMouseDown: (e)=> e.preventDefault() }}
            size={'small'}
            style={{ width: "100%"}}
            freeSolo
             renderInput={(params) => (//
                <div className="flex-centered">       
                     <TextField {...params } label="Work Instruction" inputRef={inputRef} /> 
                     <div onClick={saveModal} className="EmbeddedWIBUtton" ><img style={{width:"inherit",height:"inherit"}} src={saveIcon} /></div>
                     <div onClick={closeModal} className="EmbeddedWIBUtton" ><img style={{width:"inherit",height:"inherit"}} src={exitIcon}/></div>
                     {/* <button  id="CloseWIMenuButton" >X</button> */}
                </div>
            )}
       />
       </div>
    );
}